export default __webpack_public_path__ + "static/random-coffee-a7dc7f60754e5b826f4901c7b9a64267.svg";